// @flow
import { ACTIONS, isMessagingNotificationType } from '../constants';
import setNotificationsAsViewed from '../api/setNotificationsAsViewed';

const markMessagingNotificationsAsViewed = () => (
    dispatch: Function,
    getState: Function
) => {
    const { notifications } = getState();
    const { notificationsList, notificationsLookup } = notifications;

    const nonMessagingNotifications = notificationsList.filter(
        (notification: NotificationId) =>
            isMessagingNotificationType(notificationsLookup[notification].type)
    );

    if (notificationsList.length) {
        setNotificationsAsViewed(nonMessagingNotifications);

        dispatch({
            type: ACTIONS.NOTIFICATIONS_VIEWED
        });
    }
};

export default markMessagingNotificationsAsViewed;
